export default "__VITE_ASSET__2fd93885__"